"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledTextAreaSubject = exports.StyledMessages = exports.StyledMessage = exports.StyledEditField = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Message = _interopRequireWildcard(require("../Message2"));
var _InfiniteList = _interopRequireDefault(require("../../../InfiniteList"));
var _iconsReact = require("../../../../icons-react");
var _OnClickOutside = _interopRequireDefault(require("../../../OnClickOutside"));
var _Messenger = _interopRequireWildcard(require("../Messenger"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getItemKey = function getItemKey(index, data) {
  if (!data || !(0, _has2["default"])(data, "".concat(index, ".id"))) {
    return index;
  }
  return data[index].id;
};
var StyledMessages = exports.StyledMessages = (0, _styledComponents["default"])(_InfiniteList["default"]).withConfig({
  displayName: "Conversation2__StyledMessages",
  componentId: "sc-aako3b-0"
})(["position:relative;"]);
var StyledMessage = exports.StyledMessage = (0, _styledComponents["default"])(_Message["default"]).withConfig({
  displayName: "Conversation2__StyledMessage",
  componentId: "sc-aako3b-1"
})(["border-radius:0;width:100%;"]);
var Conversation2 = function Conversation2(_ref) {
  var _listRef$current2;
  var messages = _ref.messages,
    historyMessages = _ref.historyMessages,
    subject = _ref.subject,
    hasNextPage = _ref.hasNextPage,
    isNextPageLoading = _ref.isNextPageLoading,
    onLoadRequest = _ref.onLoadRequest,
    onLoadHistoryMessages = _ref.onLoadHistoryMessages,
    onRevealServiceMessages = _ref.onRevealServiceMessages,
    onClick = _ref.onClick,
    className = _ref.className,
    isDisableChangeSubject = _ref.isDisableChangeSubject,
    onChangeSubject = _ref.onChangeSubject,
    unreadMessages = _ref.unreadMessages,
    sentMessagesCounter = _ref.sentMessagesCounter,
    isCreate = _ref.isCreate,
    printMessageHref = _ref.printMessageHref,
    rootTicketId = _ref.rootTicketId,
    rootChainId = _ref.rootChainId,
    type = _ref.type,
    subAgentName = _ref.subAgentName,
    onForwardMessage = _ref.onForwardMessage,
    onForwardChain = _ref.onForwardChain,
    isClosedTicket = _ref.isClosedTicket;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isHistoryConversation = _useState2[0],
    setIsHistoryConversation = _useState2[1];
  var _useState3 = (0, _react.useState)(subject),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    subjectValue = _useState4[0],
    setSubjectValue = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isEditable = _useState6[0],
    setIsEditable = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    isHeaderShadow = _useState8[0],
    setIsHeaderShadow = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    isGotoBottomShow = _useState10[0],
    setIsGotoBottomShow = _useState10[1];
  var listRef = (0, _react.useRef)();
  var allMessages = (0, _react.useMemo)(function () {
    if ((0, _isArray2["default"])(historyMessages)) {
      return [].concat((0, _toConsumableArray2["default"])(historyMessages), (0, _toConsumableArray2["default"])(messages));
    }
    return messages;
  }, [messages, historyMessages]);
  var handleScrollMessages = (0, _react.useCallback)(function (event) {
    setIsHeaderShadow(event.scrollOffset > 30);
    setIsGotoBottomShow(true);
  });
  var isItemLoaded = (0, _react.useCallback)(function (index) {
    return !hasNextPage || index < messages.length - 1;
  }, [hasNextPage, messages]);
  var handleToggleEditable = (0, _react.useCallback)(function () {
    setIsEditable(function (prevIsEditable) {
      return !prevIsEditable;
    });
  });
  var handleLoadRequest = (0, _react.useCallback)(function () {
    if (isNextPageLoading || !hasNextPage) {
      return null;
    }
    return onLoadRequest();
  });
  var handleChangeSubject = (0, _react.useCallback)(function (event) {
    var value = event.target.value;
    setSubjectValue(value);
    onChangeSubject(value);
  });
  var handleClickGotoBottom = (0, _react.useCallback)(function () {
    var lastMessageIndex = (0, _size2["default"])(allMessages) - 1;
    listRef.current.scrollToItem(lastMessageIndex);
  }, [allMessages]);
  var handleScrollBottomBorder = (0, _react.useCallback)(function () {
    setIsGotoBottomShow(false);
  });
  var renderMessages = (0, _react.useCallback)(function (_ref2) {
    var data = _ref2.data,
      index = _ref2.index,
      style = _ref2.style;
    if (!data || !data[index]) {
      return null;
    }
    var _data$index = data[index],
      client = _data$index.client,
      message = _data$index.message;
    return /*#__PURE__*/_react["default"].createElement(StyledMessage, {
      isLast: !historyMessages && index === 0,
      isEmail: type === _Messenger.Types.MAIL,
      rootTicketId: rootTicketId,
      rootChainId: rootChainId,
      onLoadHistoryMessages: onLoadHistoryMessages,
      onRevealServiceMessages: onRevealServiceMessages,
      key: message.id,
      client: client,
      "data-id": message.id,
      "data-read": message.isRead,
      "data-auto": message.isAuto,
      "data-delivered": message.isDelivered,
      "data-incoming": message.isIncoming,
      "data-hidden": message.isHidden,
      message: message,
      style: style,
      onForwardMessage: onForwardMessage,
      isClosedTicket: isClosedTicket
    });
  }, [messages, historyMessages, rootChainId]);
  var handleHistoryConversationStart = (0, _react.useCallback)(function (renderProps) {
    if (!isHistoryConversation && listRef.current && !(0, _isEmpty2["default"])(historyMessages)) {
      var lastMessagesIndex = (0, _size2["default"])(allMessages) - (0, _size2["default"])(messages);
      listRef.current.scrollToItem(lastMessagesIndex);
      setIsHistoryConversation(true);
    }
    if (hasNextPage) {
      var _listRef$current;
      var innerHeight = renderProps.height;
      var containerHeight = listRef === null || listRef === void 0 || (_listRef$current = listRef.current) === null || _listRef$current === void 0 || (_listRef$current = _listRef$current._outerRef) === null || _listRef$current === void 0 ? void 0 : _listRef$current.clientHeight;
      if (containerHeight > innerHeight) onLoadRequest();
    }
  }, [listRef === null || listRef === void 0 || (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.height, isHistoryConversation, allMessages, historyMessages, messages, hasNextPage]);
  (0, _react.useEffect)(function () {
    setSubjectValue(subject);
  }, [subject]);
  (0, _react.useEffect)(function () {
    if (listRef.current && sentMessagesCounter > 0) {
      var lastMessageIndex = (0, _size2["default"])(allMessages) - 1;
      listRef.current.scrollToItem(lastMessageIndex, 'start');
    }
  }, [sentMessagesCounter, allMessages]);
  return /*#__PURE__*/_react["default"].createElement(StyledConversation, {
    className: className,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(StyledHeader, {
    isHeaderShadow: isHeaderShadow
  }, /*#__PURE__*/_react["default"].createElement(StyledHeaderContainer, null, isEditable || isCreate ? /*#__PURE__*/_react["default"].createElement(StyledOnClickOutside, {
    onClickOutside: handleToggleEditable
  }, /*#__PURE__*/_react["default"].createElement(StyledTextAreaSubject, {
    placeholder: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0442\u0435\u043C\u0443",
    onChange: handleChangeSubject,
    value: subjectValue
  })) : /*#__PURE__*/_react["default"].createElement(StyledSubject, null, /*#__PURE__*/_react["default"].createElement(StyledMessenger, {
    type: type
  }), subjectValue, !isDisableChangeSubject && isCreate && /*#__PURE__*/_react["default"].createElement(StyledEditField, {
    onClick: handleToggleEditable
  }, /*#__PURE__*/_react["default"].createElement(StyledEditFieldIcon, null))), /*#__PURE__*/_react["default"].createElement("a", {
    href: printMessageHref,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(StyledPrintIcon, null))), Boolean(subAgentName) && /*#__PURE__*/_react["default"].createElement(StyledSubAgentName, {
    $hasPaddingLeft: !(isEditable || isCreate)
  }, subAgentName)), !isCreate ? /*#__PURE__*/_react["default"].createElement(StyledContainer, null, !(0, _isEmpty2["default"])(allMessages) && /*#__PURE__*/_react["default"].createElement(StyledMessages, {
    flexible: true,
    isReverse: true,
    isNextPageLoading: isNextPageLoading,
    itemCount: (0, _size2["default"])(allMessages),
    isItemLoaded: isItemLoaded,
    onLoadRequest: handleLoadRequest,
    onScrollBottomBorder: handleScrollBottomBorder,
    onScroll: handleScrollMessages,
    itemData: allMessages,
    itemKey: getItemKey,
    onItemsRendered: handleHistoryConversationStart,
    ref: listRef
  }, renderMessages), /*#__PURE__*/_react["default"].createElement(StyledGotoBottomButton, {
    isShow: isGotoBottomShow,
    onClick: handleClickGotoBottom
  }, unreadMessages > 0 && /*#__PURE__*/_react["default"].createElement(StyledUnreadMessagesCount, null, unreadMessages), /*#__PURE__*/_react["default"].createElement(StyledArrowIcon, {
    unreadMessages: unreadMessages
  })), type === _Messenger.Types.MAIL && !isClosedTicket && /*#__PURE__*/_react["default"].createElement(StyledForwardChainButton, {
    onClick: function onClick() {
      return onForwardChain(true);
    },
    isShownGotoBottomButton: isGotoBottomShow
  }, /*#__PURE__*/_react["default"].createElement("span", null, "\u041F\u0435\u0440\u0435\u0441\u043B\u0430\u0442\u044C \u0446\u0435\u043B\u0438\u043A\u043E\u043C"), /*#__PURE__*/_react["default"].createElement(StyledForwardIcon, null))) : /*#__PURE__*/_react["default"].createElement(StyledNoFound, null, /*#__PURE__*/_react["default"].createElement(StyledHead, null, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0442\u0435\u043C\u0443 \u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F"), /*#__PURE__*/_react["default"].createElement(StyledBody, null, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0442\u0435\u043C\u0443 \u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F", /*#__PURE__*/_react["default"].createElement("br", null), "\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435")));
};
Conversation2.propTypes = {
  className: _propTypes["default"].string,
  messages: _propTypes["default"].arrayOf(_Message.MessageType),
  historyMessages: _propTypes["default"].arrayOf(_Message.MessageType),
  hasNextPage: _propTypes["default"].bool,
  isNextPageLoading: _propTypes["default"].bool,
  onRevealServiceMessages: _propTypes["default"].func,
  subject: _propTypes["default"].string,
  onLoadRequest: _propTypes["default"].func,
  onChangeSubject: _propTypes["default"].func,
  isDisableChangeSubject: _propTypes["default"].bool,
  unreadMessages: _propTypes["default"].number,
  sentMessagesCounter: _propTypes["default"].number,
  isCreate: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  type: _propTypes["default"].oneOf(Object.values(_Messenger.Types)),
  printMessageHref: _propTypes["default"].string,
  rootTicketId: _propTypes["default"].number,
  rootChainId: _propTypes["default"].number,
  onLoadHistoryMessages: _propTypes["default"].func
};
Conversation2.defaultProps = {
  className: '',
  messages: [],
  historyMessages: null,
  hasNextPage: true,
  isNextPageLoading: false,
  subject: null,
  onLoadRequest: Function.prototype,
  onChangeSubject: Function.prototype,
  onRevealServiceMessages: Function.prototype,
  isDisableChangeSubject: false,
  unreadMessages: 0,
  sentMessagesCounter: 0,
  isCreate: false,
  onClick: Function.prototype,
  type: null,
  printMessageHref: '',
  rootTicketId: null,
  rootChainId: null,
  onLoadHistoryMessages: Function.prototype
};
var StyledConversation = _styledComponents["default"].div.withConfig({
  displayName: "Conversation2__StyledConversation",
  componentId: "sc-aako3b-2"
})(["position:relative;border-radius:4px;box-shadow:0 10px 15px 0 rgba(196,194,182,0.9),0 1px 2px 0 rgba(210,208,197,0.9);width:100%;height:100%;background-color:#fff;display:flex;flex-direction:column;flex-grow:1;"]);
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "Conversation2__StyledHeader",
  componentId: "sc-aako3b-3"
})(["min-height:22px;padding:11px 10px 9px 10px;position:relative;&:after{display:", ";content:'';position:absolute;left:0;top:100%;right:0;height:59px;background:linear-gradient( to bottom,#fff,rgba(255,255,255,0.6),rgba(255,255,255,0) );z-index:1;}"], function (_ref3) {
  var isHeaderShadow = _ref3.isHeaderShadow;
  return isHeaderShadow ? 'block' : 'none';
});
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "Conversation2__StyledContainer",
  componentId: "sc-aako3b-4"
})(["flex-grow:2;"]);
var StyledEditField = exports.StyledEditField = _styledComponents["default"].span.withConfig({
  displayName: "Conversation2__StyledEditField",
  componentId: "sc-aako3b-5"
})(["position:relative;"]);
var StyledEditFieldIcon = (0, _styledComponents["default"])(_iconsReact.EditField).withConfig({
  displayName: "Conversation2__StyledEditFieldIcon",
  componentId: "sc-aako3b-6"
})(["width:16px;height:15px;position:relative;left:4px;"]);
var StyledArrowIcon = (0, _styledComponents["default"])(function (_ref4) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref4), _ref4));
  return /*#__PURE__*/_react["default"].createElement(_iconsReact.Arrow, props);
}).withConfig({
  displayName: "Conversation2__StyledArrowIcon",
  componentId: "sc-aako3b-7"
})(["width:20px;height:19px;margin-top:", ";path{stroke:", ";}"], function (_ref5) {
  var unreadMessages = _ref5.unreadMessages;
  return unreadMessages > 0 ? '15px' : '12px';
}, function (_ref6) {
  var unreadMessages = _ref6.unreadMessages;
  return unreadMessages > 0 ? '#007AFF' : '#919499';
});
var StyledOnClickOutside = (0, _styledComponents["default"])(_OnClickOutside["default"]).withConfig({
  displayName: "Conversation2__StyledOnClickOutside",
  componentId: "sc-aako3b-8"
})(["width:100%;"]);
var StyledTextAreaSubject = exports.StyledTextAreaSubject = _styledComponents["default"].textarea.withConfig({
  displayName: "Conversation2__StyledTextAreaSubject",
  componentId: "sc-aako3b-9"
})(["width:100%;height:100%;font-size:18px;font-family:'Backpack',sans-serif;font-weight:bold;line-height:22px;color:#17181a;border:0;resize:none;&::placeholder{font-weight:normal;color:#919499;}"]);
var StyledHeaderContainer = _styledComponents["default"].div.withConfig({
  displayName: "Conversation2__StyledHeaderContainer",
  componentId: "sc-aako3b-10"
})(["display:flex;"]);
var StyledSubject = _styledComponents["default"].div.withConfig({
  displayName: "Conversation2__StyledSubject",
  componentId: "sc-aako3b-11"
})(["width:100%;height:100%;font-size:18px;font-weight:bold;line-height:22px;color:#17181a;border:0;display:flex;align-items:start;"]);
var StyledMessenger = (0, _styledComponents["default"])(_Messenger["default"]).withConfig({
  displayName: "Conversation2__StyledMessenger",
  componentId: "sc-aako3b-12"
})(["min-height:16px;width:16px;margin-right:6px;margin-top:2px;"]);
var StyledNoFound = _styledComponents["default"].div.withConfig({
  displayName: "Conversation2__StyledNoFound",
  componentId: "sc-aako3b-13"
})(["align-items:center;border:1px dashed #919499;border-radius:4px;display:flex;flex-direction:column;height:100%;justify-content:center;"]);
var StyledHead = _styledComponents["default"].div.withConfig({
  displayName: "Conversation2__StyledHead",
  componentId: "sc-aako3b-14"
})(["color:#17181a;font-size:22px;font-weight:700;"]);
var StyledBody = _styledComponents["default"].div.withConfig({
  displayName: "Conversation2__StyledBody",
  componentId: "sc-aako3b-15"
})(["color:#4d4d4d;line-height:19px;text-align:center;", " + &{margin-top:15px;}"], StyledHead);
var StyledGotoBottomButton = _styledComponents["default"].button.withConfig({
  displayName: "Conversation2__StyledGotoBottomButton",
  componentId: "sc-aako3b-16"
})(["position:absolute;display:", ";justify-content:center;box-shadow:0 2px 10px rgba(23,24,26,0.15);bottom:8px;right:8px;width:40px;height:40px;border-radius:100%;border:none;outline:none;cursor:pointer;background:#ffffff;"], function (_ref7) {
  var isShow = _ref7.isShow;
  return isShow ? 'flex' : 'none';
});
var StyledForwardIcon = (0, _styledComponents["default"])(_iconsReact.Forward).withConfig({
  displayName: "Conversation2__StyledForwardIcon",
  componentId: "sc-aako3b-17"
})(["width:20px;height:20px;transition:all 0.5s;"]);
var StyledForwardChainButton = _styledComponents["default"].button.withConfig({
  displayName: "Conversation2__StyledForwardChainButton",
  componentId: "sc-aako3b-18"
})(["@keyframes slideSpan{from{right:100%;}to{right:35px;}}position:absolute;display:flex;justify-content:right;align-items:center;box-shadow:0 2px 10px rgba(23,24,26,0.15);bottom:8px;right:", ";width:40px;height:40px;border-radius:20px;border:none;cursor:pointer;background:#ffffff;transition:all 0.5s;overflow:hidden;padding:0 10px;& span{white-space:nowrap;opacity:0;font-size:12px;position:absolute;left:-120px;left:", ";transition:left 0.5s,opacity 0.5s;}&:hover{width:155px;border-radius:20px;padding:0px 10px;}&:hover ", "{width:20px;height:20px;margin-left:auto;}&:hover span{opacity:1;left:10px;animation:slideSpan 0.5s forwards;}"], function (_ref8) {
  var isShownGotoBottomButton = _ref8.isShownGotoBottomButton;
  return isShownGotoBottomButton ? '68px' : '8px';
}, function (_ref9) {
  var isShownGotoBottomButton = _ref9.isShownGotoBottomButton;
  return isShownGotoBottomButton ? '-180px' : '-120px';
}, StyledForwardIcon);
var StyledUnreadMessagesCount = _styledComponents["default"].div.withConfig({
  displayName: "Conversation2__StyledUnreadMessagesCount",
  componentId: "sc-aako3b-19"
})(["position:absolute;top:8px;background:white;font-size:12px;font-weight:700;color:#007aff;"]);
var StyledPrintIcon = (0, _styledComponents["default"])(_iconsReact.Print).withConfig({
  displayName: "Conversation2__StyledPrintIcon",
  componentId: "sc-aako3b-20"
})(["width:22px;height:19px;cursor:pointer;width:25px;margin-left:5px;margin-top:5px;"]);
var StyledSubAgentName = _styledComponents["default"].div.withConfig({
  displayName: "Conversation2__StyledSubAgentName",
  componentId: "sc-aako3b-21"
})(["font-size:14px;font-weight:700;color:#4b137b;margin-top:5px;", ""], function (_ref10) {
  var $hasPaddingLeft = _ref10.$hasPaddingLeft;
  return $hasPaddingLeft && 'padding-left: 22px;';
});
var _default = exports["default"] = Conversation2;